"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAssignedRepaymentTapeSchema = exports.InternalRepaymentTapeSchema = exports.InternalRepaymentEntrySchema = exports.IntermediateRepaymentTapeSchema = exports.IntermediateRepaymentEntrySchema = void 0;
const zod_1 = require("zod");
const RepaymentEntry_1 = require("./RepaymentEntry");
const Utils_1 = require("./Utils");
// ***************************************
// ***     Intermediate Structure      ***
// ***************************************
exports.IntermediateRepaymentEntrySchema = zod_1.z.object({
    externalReceivableId: zod_1.z.string(),
    baseFields: RepaymentEntry_1.RepaymentEntryBaseFieldsSchema,
    normalizedFields: RepaymentEntry_1.NormalizedRepaymentFieldsSchema,
});
exports.IntermediateRepaymentTapeSchema = zod_1.z.object({
    loanProductId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string().nullable(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    fileVersion: zod_1.z.number(),
    repaymentEntries: zod_1.z.array(exports.IntermediateRepaymentEntrySchema),
});
// ***************************************
// ***       Internal Structure        ***
// ***************************************
exports.InternalRepaymentEntrySchema = exports.IntermediateRepaymentEntrySchema.extend({
    finleyReceivableId: zod_1.z.string(),
});
exports.InternalRepaymentTapeSchema = exports.IntermediateRepaymentTapeSchema.extend({
    repaymentEntries: zod_1.z.array(exports.InternalRepaymentEntrySchema),
});
// ***************************************
//            Assigned Structure
// ***************************************
/**
 * For "assigned" version of internal repayment tape, we know the associated CF
 * so can simply set it as definitive here
 */
exports.InternalAssignedRepaymentTapeSchema = exports.InternalRepaymentTapeSchema.extend({
    creditFacilityId: zod_1.z.string(),
});
//# sourceMappingURL=RepaymentTape.js.map